import { render, staticRenderFns } from "./CardInput.vue?vue&type=template&id=72363d2e"
import script from "./CardInput.vue?vue&type=script&lang=js"
export * from "./CardInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CardInput.vue"
export default component.exports